import * as vars from "./mutations-vars.js";

export default {
  [vars.SET_OSS](state, currentOSS) {
    if (currentOSS) {
      sessionStorage.setItem("oss", currentOSS);
    } else {
      sessionStorage.removeItem("oss");
    }
    state.oss = currentOSS;
  },
  [vars.SET_USER](state, currentUser) {
    state.user = currentUser;
  },
  [vars.SET_STATE](state, s) {
    state.isLogin = s;
  },
  [vars.CLEAN_USER](state) {
    state.user.username = "";
    state.user.id = "";
  },
  [vars.regionWidthChangedNum](state) {
    state.regionWidthChangedNum += 1;
  },
  [vars.SET_IS_MIGRATORY](state, value) {
    const migrator = [12, 26, 30, 37];
    state.isMigratory = migrator.includes(value);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js